import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import { useGetSubCategoryQuery } from "../../../features/api/subcategoryApi";
import { useAddSalesRateMutation } from "../../../features/api/salesratemainApi";
import { MdAdd } from "react-icons/md";
import { API_BASE_URL } from "../../../components/baseUrl";

const AddNewSalesRate = ({ rate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setIsOpen(false);
    document.body.style.overflow = "auto";
  };
  const { data, error, isLoading } = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const subCategories = data?.subcategories;

  const [createNewSalesRate] = useAddSalesRateMutation();

  const [sub_cat, setSubCategory] = useState("");
  console.log(sub_cat);
  const [pro_name, setProduct] = useState("");
  const [unit_price, setUnitRate] = useState(0);
  const [sales_rate, setSalesRate] = useState(0);

  // fetch product by Brand name
  const [getProductBySubCat, setGetProductBySubCat] = useState([]);
  useEffect(() => {
    fetch(
      `${API_BASE_URL}/api/subCatProducts?subCategory=${sub_cat}`
    )
      .then((res) => res.json())
      .then((data) => {
        setGetProductBySubCat(data?.product);
      });
  }, [sub_cat]);

  const handleAddNew = async () => {
    try {
      const newSalesRate = [
        {
          sub_cat: sub_cat,
          pro_name: pro_name,
          unit_price: unit_price,
          sales_rate: sales_rate,
        },
      ];
      const response = await createNewSalesRate(newSalesRate);
      if (response) {
        setIsOpen(false);
        document.body.style.overflow = "auto";
        toast.success("Added Successful...!!!");
        //   setTimeout(() => {
        //     window.location.reload();
        //   }, 5);
      }
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };
  return (
    <div>
      <span
        onClick={openModal}
        className="flex items-center p-1 text-white bg-blue-500 font-bold cursor-pointer"
      >
        <MdAdd size={25} /> Add New
      </span>

      {isOpen && (
        <div className="fixed top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded shadow-md md:w-[500px]">
            <button
              className="text-red-500 font-bold float-right"
              onClick={closeModal}
            >
              X
            </button>
            <div className="card bg-base-100 overflow-auto mt-6">
              <div className="card-body">
                <div className="text-center">
                  <h2 className=" font-bold mb-4">New Sales Rate Entry </h2>
                </div>
                <div
                  className="flex flex-col items-start font-extralight p-4"
                  style={{ lineHeight: "30px" }}
                >
                  <div className="grid grid-cols-2 gap-4 w-full">
                    <div className="flex flex-col justify-between">
                      <label className="font-bold">Brand: </label>
                      <select
                        onChange={(e) => setSubCategory(e.target.value)}
                        className="border pl-1 h-8"
                      >
                        <option>--select--</option>
                        {subCategories?.map((category) => (
                          <option key={category?.id} value={category?.id}>
                            {category?.sub_catName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex flex-col justify-between">
                      <label className="font-bold">Product: </label>
                      <select
                        onChange={(e) => setProduct(e.target.value)}
                        className="border pl-1 h-8"
                      >
                        <option>--select--</option>
                        {getProductBySubCat?.map((product) => (
                          <option key={product?.id} value={product?.id}>
                            {product?.product_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="flex flex-col justify-between">
                      <label className="font-bold">Purchase Rate:</label>
                      <input
                        type="number"
                        onChange={(e) => setUnitRate(e.target.value)}
                        className={`border pl-1 `}
                      />
                    </div>
                    <div className="flex flex-col justify-between">
                      <label className="font-bold">Sales Rate:</label>
                      <input
                        type="number"
                        onChange={(e) => setSalesRate(e.target.value)}
                        className={`border pl-1 `}
                      />
                    </div>
                  </div>
                  <button
                    onClick={() => handleAddNew()}
                    className="bg-green-500 text-white font-bold mt-6 px-4 block m-auto"
                  >
                    Added
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddNewSalesRate;
